module.exports = __webpack_public_path__ + "img/max-file-approve--json.bb46801d.svg";